import { GLOBAL_NAME } from '../constants/Globals';
export default function handleGetCapabilities() {
  return window[GLOBAL_NAME].capabilities;
}